import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input,Switch } from "antd";
import axios from "axios";
import { jwtDecode } from 'jwt-decode'; // Importation corrigée


const Temoignage = () => {
  const [contenu, setContenu] = useState("");
  const [image, setImage] = useState("");
  const [categorieId, setCategorieId] = useState("");
  const [data, setData] = useState([]);

  const [sviewingProjet, setSviewingProjet] = useState("");

  const [description, setDescription] = useState("");
  const [projets, setProjets] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingProjet, setEditingProjet] = useState(null);
  const [viewingProjet, setViewingProjet] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const imageUrl = projets.images ? `http://localhost:8081/api/images/${projets.images}` : 'default-image.jpg'; // Remplacer par une image par défaut si `images` est null
  const [currentUser, setCurrentUser] = useState(null); // État pour stocker l'utilisateur 

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupérer le premier fichier sélectionné
    if (file) {
      setImage(file); // Mettre à jour l'état avec l'image sélectionnée
    }
  };
  

  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "..."; // Tronque et ajoute "..."
    }
    return text; // Retourne le texte sans changement si le nombre de mots est inférieur à la limite
  };


  const fetchProjets = async () => {
    try {
      const response = await axios.get("http://localhost:8081/api/plateforme/temoignage");
  
      // Vérification du statut HTTP de la réponse
      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
  
      // Les données sont accessibles directement via `response.data` avec axios
      const data = response.data;
  
      if (!data || data.length === 0) {
        console.warn("Aucun projet trouvé.");
      }
  
      // Met à jour l'état avec les projets récupérés
      setProjets(data);
    } catch (error) {
      console.error("Erreur lors du chargement des projets:", error.message || error);
      openNotificationWithIcon("error", "Erreur lors de la récupération des projets.");
    }
  };
  

 
   

  useEffect(() => {
    const token = localStorage.getItem('token'); // Assurez-vous que c'est le bon nom de clé
    if (token) {
      try {
        const decoded = jwtDecode(token); // Utilisation de jwtDecode
        setCurrentUser(decoded); // Décodez et stockez les informations de l'utilisateur
        console.log("Utilisateur connecté:", decoded); // Vérifiez les informations de l'utilisateur
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage."); // Avertir si aucun token n'est trouvé
    }
    fetchProjets();
  }, []);


  const handleAddTemoignage = async (e) => {
    e.preventDefault();

    if (!contenu) {
      openNotificationWithIcon("error", "Veuillez remplir le nom de la catégorie.");
      return;
    }

    const categoryData = {
      contenu: contenu,
    };

    try {
      const response = await fetch("http://localhost:8081/api/plateforme/temoignage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(categoryData),
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const newTemoignage = await response.json();
// Ajouter le nouveau témoignage à l'état des projets sans rafraîchir la page
      setProjets([newTemoignage, ...projets]);      
      openNotificationWithIcon("success", "Catégorie ajoutée avec succès.");
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout de la catégorie.");
      console.error("Erreur:", error);
    }

    resetForm();
  };
  


  const handleAddProjet = async (e) => {
    e.preventDefault();
  
    if (!contenu ) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }
  
    try {
      // const token = localStorage.getItem("token");
      // if (!token) {
      //   openNotificationWithIcon("error", "Utilisateur non authentifié. Veuillez vous connecter.");
      //   return;
      // }
  
      // const formData = new FormData();
      // formData.append("contenu", contenu);
      // formData.append("description", description);
      // formData.append("categorieId", selectedCategorie);
      // formData.append("image", image);

      const temoinData = {
        contenu: contenu,
      };
  
  
      const response = await fetch("http://localhost:8081/api/plateforme/temoignage", temoinData)
      //   {
      //   method: "POST",
      //   // headers: {
      //   //   Authorization: `Bearer ${token}`,
      //   // },
      //   body: temoinData,
      // });
      //console.log("donnné:",response);
  
      // Vérifier le statut de la réponse
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Erreur API:", errorText);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
  
      // Lire la réponse comme texte (pas JSON)
      const message = await response.text();
      console.log("Réponse texte:", message);
  
      // Notification de succès
      openNotificationWithIcon("success", message);
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout du temoignage.");
      console.error("Erreur détectée:", error.message || error);
    }
  
    resetForm();
  };
  
 

  const handleEditProjet = async (e) => {
    e.preventDefault();
    if (!contenu || !description || !imageUrl ) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }
    const projetData = { contenu, description, image,categorieId };

    try {
      const response = await fetch(`http://localhost:8081/api/projet/update/${editingProjet.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(projetData),
      });
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      const updatedProjet = await response.json();
      setProjets(projets.map((projet) => (projet.id === updatedProjet.id ? updatedProjet : projet)));
      openNotificationWithIcon("success", "Projet modifié avec succès.");
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de la modification du projet.");
      console.error("Erreur:", error);
    }
    resetForm();
  };

  const handleDelete = async (idProjet) => {
    try {
      const response = await fetch(`http://localhost:8081/api/projet/delete/${idProjet}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      setProjets(projets.filter((projet) => projet.id !== idProjet));
      openNotificationWithIcon("success", "Projet supprimé avec succès.");
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de la suppression du projet.");
      console.error("Erreur:", error);
    }
  };

  const handleStatusChange = (key, value) => {
    const newData = data.map(item => {
      if (item.key === key) {
        return {
          ...item,
          actif: value,
        };
      }
      return item;
    });
    setData(newData);
  };

  const resetForm = () => {
    setContenu("");
    setDescription("");
    setImage("");
    setIsEditMode(false);
    setEditingProjet(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleEdit = (projet) => {
    setIsEditMode(true);
    setEditingProjet(projet);
    setcontenu(projet.contenu);
    setDescription(projet.description);
    setImage(projet.image);
    setIsEditModalVisible(true);
  };

  const handleView = (projet) => {
    setViewingProjet(projet);
    setIsViewModalVisible(true);
  };

  const filteredProjets = projets.filter((projet) =>
    projet.contenu && projet.contenu.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Temoignages</h3>
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                  type="primary"
                  onClick={() => setIsAddModalVisible(true)}
                  className="float-end mt-2"
                >
                  Ajouter un Temoignage
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              {
                title: "Message",
                dataIndex: "contenu",
                key: "contenu",
                // render: (text) => truncateText(text, 5), // Tronque le contenu à 5 mots
              },
              {
                title: "Utilisateur",
                dataIndex: "description",
                key: "description",
                // render: (text) => truncateText(text, 5), // Tronque la description à 10 mots
              }, 
              {
                title: "Etat",
                dataIndex: "actif",
                key: "actif",
                render: (actif, record) => (
                  <Switch
                    checked={actif}
                    onChange={(checked) => handleStatusChange(record.key, checked)}
                  />
                ),
              },
                         
              {
                title: "Image",
                dataIndex: "images",
                key: "images",
                render: (imageName) => {
                  // Définir le chemin complet de l'image
                  const imageUrl = `http://localhost:8081/api/images/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="project"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },              {
                title: "Actions",
                key: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => handleView(record)}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => handleEdit(record)}
                    >
                      Modifier
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDelete(record.id)}
                    >
                      Supprimer
                    </Button>
                  </div>
                ),
              },

            ]}
            dataSource={filteredProjets}
          />

          {/* Modal d'ajout de catégorie */}
          <Modal
            title="Ajouter un projet"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsAddModalVisible(false)}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleAddProjet}>
                Ajouter
              </Button>,
            ]}
          >
            <form onSubmit={handleAddTemoignage}>
                <div>
                 
                  {/* Description */}
                  <label htmlFor="contenu">Message:</label>
                  <Input.TextArea
                    id="contenu"
                    value={contenu}
                    onChange={(e) => setContenu(e.target.value)}
                    placeholder="Entrez la description"
                  /> 

                 

          
                  {/* Bouton de soumission */}
                  <button type="submit" className="btn btn-primary">
                    Ajouter temoignage
                  </button>
                </div>
          </form>


          </Modal>

          {/* Modal de modification de projet */}
          <Modal
            title="Modifier le projet"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsEditModalVisible(false)}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleEditProjet}>
                Enregistrer les modifications
              </Button>,
            ]}
          >
            <form onSubmit={handleEditProjet}>
            <div>
              <label>contenu:</label>
                <Input
                  value={contenu}
                  onChange={(e) => setcontenu(e.target.value)}
                  placeholder="Entrez le contenu du projet"
                />
                <label>Description:</label>
                <Input.TextArea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Entrez la description"
                />
                
                <Input
                  type="file"
                  value={imageUrl}
                  onChange={(e) => setImage(e.target.value)}
                  placeholder="Selectionner une image"
                />
                
                
              </div>
            </form>
          </Modal>

          {/* Modal pour afficher les détails  */}
          <Modal
            title="Détails du projet"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
          >
            {viewingProjet && (
              <div>
                  <h4>{viewingProjet?.contenu}</h4>
                  <p><strong>Description:</strong> {viewingProjet?.description}</p>
                  <p><strong>URL de l'image:</strong> {sviewingProjet?.imageUrl}</p>
               </div>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Temoignage;
